/**
 * Created by forbiz on 2019-02-11.
 */
const front_common = () => {
    
}


export default front_common;